<ion-card
  mode="ios"
  color="white"
  class="card-promocion"
  type="button"
  button
  (click)="openModalDetail()"
>
  <ng-container *ngIf="item.Tipo === 1">
    <ion-img
      [src]="item.Recurso"
      class="image-card"
      (ionError)="onImageError($event)"
    ></ion-img>
  </ng-container>

  <!-- iOS nativo: thumbnail + play -->
  <ng-container *ngIf="item.Tipo === 2 && isIos">
    <div class="video-thumbnail" (click)="openYouTubeApp($event)">
      <ion-img
        [src]="thumbnailUrl"
        class="image-card"
        (ionError)="onThumbnailError($event)"
      ></ion-img>
      <div class="play-button-overlay">
        <ion-icon name="play-circle" class="play-icon"></ion-icon>
      </div>
    </div>
  </ng-container>

  <!-- Web y Android: iframe -->
  <ng-container *ngIf="item.Tipo === 2 && !isIos">
    <iframe
      width="100%"
      height="150"
      frameborder="0"
      allowfullscreen
      [src]="item.Recurso | videoSan"
    ></iframe>
  </ng-container>

  <ion-item color="white" mode="md" lines="none">
    <ion-label color="status-icon-enable" mode="md">
      <p class="mpe-font-weight-600 title-card">{{ item.Titulo }}</p>
      <p class="date-card">{{ item.FechaVigenciaInicial }}</p>
    </ion-label>

    <ion-icon
      name="add-circle"
      color="danger"
      slot="end"
      class="icon-more"
    ></ion-icon>
  </ion-item>
</ion-card>
